global?.modules?.set({
  name: 'tabs',
  is_booted: false,
  async init() {
    if (this.is_booted) return;
    this.is_booted = true;

    initTestimonialsTabs();
  }
});

function initTestimonialsTabs() {
  const testimonialSections = document.querySelectorAll('.s-testimonials');

  testimonialSections.forEach(section => {
    // Знайдемо всі кнопки вкладок і контент для поточного компонента
    const tabBtns = section.querySelectorAll('.s-testimonials__tab-btn');
    const tabContents = section.querySelectorAll('.s-testimonials__list');

    // Додати обробник події для кожної кнопки вкладки
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;

        // Зняти активний клас з усіх кнопок і контентів
        tabBtns.forEach(b => b.classList.remove('is-active'));
        tabContents.forEach(c => c.classList.remove('is-active'));

        // Додати активний клас для поточної кнопки і відповідного контенту
        btn.classList.add('is-active');
        section.querySelector(`[data-tab-content="${target}"]`)?.classList.add('is-active');
      });
    });
  });
}
